module.exports = __webpack_public_path__ + "img/menucn_5_1.a155dd3a.svg";